import React from "react";
import { Container } from "../Common__style/Micro-style";
import BlueButton from "../BlueButton/BlueButon";
import * as S from "./Signup-style";


export default function Signup() {

   return (
      <S.Signup>
         <Container>
            <S.SignupBody>
               <S.SignupTitle>
                  Newsletter Signup
               </S.SignupTitle>
               <S.SignupForm>
                  <S.SignupInput type="text" />
                  <BlueButton text={'signup'} width />
               </S.SignupForm>
            </S.SignupBody>
         </Container>
      </S.Signup>
   )
}